const SILVER_PURITY_LABELS = {
  999: '999 Fine Silver',
  925: '925 Sterling Silver',
  900: '900 Coin Silver',
};

export const formatSilverPurity = (product) => {
  const fineness = Number(product?.purity_fineness);
  if (SILVER_PURITY_LABELS[fineness]) return SILVER_PURITY_LABELS[fineness];

  const purity = product?.purity?.trim();
  if (!purity) return 'Silver';
  return /silver$/i.test(purity) ? purity : `${purity} Silver`;
};

export const calculateDisplayedPrice = (product, metalRate = 0) => {
  if (!Number.isFinite(Number(metalRate)) || Number(metalRate) <= 0) return null;
  const round2 = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  const fixedSupplierCost = Number(product?.supplier_cost);
  const purityFactor = Number(product?.purity_fineness || 999) / 999;
  const metalValue = round2(Number(metalRate) * Number(product?.weight || 0) * purityFactor);
  const pricingMode = product?.pricing_mode || (fixedSupplierCost > 0 ? 'fixed_supplier_cost' : 'live_components');
  if (pricingMode === 'live_components' && (product?.supplier_wastage_percent === null || product?.supplier_wastage_percent === undefined || product?.supplier_wastage_percent === '')) return null;
  const wastageCost = round2(metalValue * Number(product?.supplier_wastage_percent) / 100);
  const supplierCost = pricingMode === 'fixed_supplier_cost' && fixedSupplierCost > 0
    ? round2(fixedSupplierCost)
    : round2(metalValue
      + wastageCost
      + Number(product?.supplier_making_cost ?? product?.making_cost ?? 0)
      + Number(product?.supplier_other_cost || 0));
  const marginPercent = Math.min(Math.max(Number(product?.margin_percent ?? 13), 0), 13);
  const gstPercent = Number(product?.gst_percent ?? 3);
  const sohmMargin = round2(supplierCost * marginPercent / 100);
  const priceBeforeTax = round2(supplierCost + sohmMargin);
  const gst = round2(priceBeforeTax * gstPercent / 100);

  return round2(priceBeforeTax + gst);
};